import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'
import AjaxApi from '../lib/AjaxApi'

export default class ProductComparison extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._productSelects = this._elem.querySelectorAll('[data-product-comparison-select]')
  }


  mount () {
    for (let select of this._productSelects) {
      this._handleSelectChange(select)

      select.addEventListener('change', () => {
        this._handleSelectChange(select)
      })
    }

    window.addEventListener('resize', () => {
      this._setProductTitleHeight()
    })
  }
 
  async _handleSelectChange(select) {
    const selectId = select.id
    const productIndex = selectId.split('-')[0]
    const handle = select.value
    const productData = handle ? await AjaxApi.getCustomProduct(handle) : null
    this._updateProductInfo(productIndex, productData)
    this._setProductTitleHeight()
  }

  _updateProductInfo(productId, productData) {
    if (productData) {
      let product = productData.product
      let metafields = productData.metafields_custom

      let productHTMLContent = ''

      if (product.type) {
        productHTMLContent = productHTMLContent + `
          <p class="product-type">${product.type}</>
        `
      }
      productHTMLContent = productHTMLContent + `
        <h3 class="product-title">${product.title}</h3>
        <p class="product-price">${product.price_varies ? 'From ' : ''} ${Helpers.formatMoney(product.price_min, this._ctx.getState())} +VAT</p>
        <div class="product-image">
          <img src="${product.featured_image}" alt="${product.title}"/>
        </div>
      `
      if (metafields.product_dimensions_length) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Length</p>
            <p class="product-details-element">${metafields.product_dimensions_length.value}${metafields.product_dimensions_length.unit}</p>
          </div>
        `
      }
      if (metafields.product_dimensions_width) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Width</p>
            <p class="product-details-element">${metafields.product_dimensions_width.value}${metafields.product_dimensions_width.unit}</p>
          </div>
        `
      }
      if (metafields.product_dimensions_height) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Height</p>
            <p class="product-details-element">${metafields.product_dimensions_height.value}${metafields.product_dimensions_height.unit}</p>
          </div>
        `
      }
      if (metafields.standard_finish) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Standard Finish</p>
            <p class="product-details-element">${metafields.standard_finish.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }
      if (metafields.finish_upgrades) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Finish Upgrades</p>
            <p class="product-details-element">${metafields.finish_upgrades.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.standard_temperature) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Standard Temperature</p>
            <p class="product-details-element">${metafields.standard_temperature.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.temperature_upgrades) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Temperature Upgrades</p>
            <p class="product-details-element">${metafields.temperature_upgrades.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.capacity) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Capacity</p>
            <p class="product-details-element">${metafields.capacity.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.filtration) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Filtration</p>
            <p class="product-details-element">${metafields.filtration.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.product_maintenance) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Maintenance</p>
            <p class="product-details-element">${metafields.product_maintenance.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.installation_type) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Installation Type</p>
            <p class="product-details-element">${metafields.installation_type.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }      
      if (metafields.customisation) {
        productHTMLContent = productHTMLContent + `
          <div>
            <p class="product-details-label">Customisation</p>
            <p class="product-details-element">${metafields.customisation.replace(/\n/g, '</br>')}</p>
          </div>
        `
      }
      
      productHTMLContent = productHTMLContent + `
        <a href="${product.url}" class="btn btn--${this._options.button_style} ${this._options.button_outline}">View Product</a>
      `

      document.querySelector(`#${productId}-info`).innerHTML = productHTMLContent
      document.querySelector(`#${productId}-info`).classList.remove('hide')

    } else {
      document.querySelector(`#${productId}-info`).innerHTML = ''
      document.querySelector(`#${productId}-info`).classList.add('hide')
    }
  }

  _setProductTitleHeight() {
    let productTitles = this._elem.querySelectorAll('.product-title')
    let maxHeight = 0

    productTitles.forEach(title => {
      title.style.height = 'auto'
    })

    productTitles.forEach(title => {
      let titleHeight = title.offsetHeight
      if (titleHeight > maxHeight) {
        maxHeight = titleHeight
      }
    })

    productTitles.forEach(title => {
      title.style.height = maxHeight + 'px'
    })
  }
}